// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { CSSTransition } from "react-transition-group";
import { List, Popup, Ref } from "semantic-ui-react";
import { useConst } from "@jvs-group/jvs-mairistem-tools";
import { ApplicationPageContext } from "../ApplicationPage";
import { Link } from "../../services/router";
import "./ApplicationMenuActionItem.less";
import { getApplicationClassName } from "../utils/className";
import { jsx as _jsx } from "react/jsx-runtime";
const className = getApplicationClassName("menu", "action", "item");
export const ApplicationMenuActionItem = props => {
  const {
    identifiant,
    icon,
    title,
    path,
    onClick,
    open,
    delay = 0
  } = props;
  const innerRef = React.useRef();
  const [inView, setInView] = React.useState(false);
  const {
    manifest
  } = React.useContext(ApplicationPageContext);

  // eslint-disable-next-line no-shadow, @typescript-eslint/no-shadow
  const routes = useConst(manifest?.menus?.map(({
    code,
    name,
    path
  }) => ({
    code,
    name,
    path
  })));
  const handleClick = React.useCallback(() => {
    onClick?.({
      module: {
        routes
      }
    });
  }, [onClick, routes]);
  React.useEffect(() => {
    React.startTransition(() => {
      setInView(open);
    });
  }, [open, setInView]);
  return /*#__PURE__*/_jsx(CSSTransition, {
    nodeRef: innerRef,
    in: inView,
    timeout: 600,
    classNames: "application-menu-action-item-transition",
    "data-sentry-element": "CSSTransition",
    "data-sentry-component": "ApplicationMenuActionItem",
    "data-sentry-source-file": "ApplicationMenuActionItem.tsx",
    children: /*#__PURE__*/_jsx(Ref, {
      innerRef: innerRef,
      "data-sentry-element": "Ref",
      "data-sentry-source-file": "ApplicationMenuActionItem.tsx",
      children: /*#__PURE__*/_jsx(Popup, {
        position: "top center",
        size: "mini",
        inverted: true,
        trigger: /*#__PURE__*/_jsx(List.Item, {
          ...(path && {
            as: Link,
            to: path
          }),
          className: className,
          style: {
            transitionDelay: `${delay}ms`
          },
          onClick: onClick && handleClick,
          children: /*#__PURE__*/_jsx(List.Icon, {
            name: icon,
            circular: true
          })
        }),
        "data-sentry-element": "Popup",
        "data-sentry-source-file": "ApplicationMenuActionItem.tsx",
        children: title
      })
    })
  }, identifiant);
};